import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-medium text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t("report.errors.report_being_prepared_error")), 1),
      _hoisted_2,
      _createElementVNode("button", {
        class: "uppercase text-medium text-primary-blue px-5 mt-3",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('reloadReport')), ["stop"])),
        innerHTML: _ctx.$t('report.reload')
      }, null, 8, _hoisted_3)
    ])
  ]))
}